var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"gl-m-0 gl-list-none gl-p-0"},[_c('li',{staticClass:"command-palette-px gl-border-t gl-border-t-dropdown gl-py-5 gl-text-default"},[_vm._v("\n    "+_vm._s(_vm.$options.i18n.NO_SEARCH_RESULTS)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }